import { MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { Observable } from "rxjs";

import { CustomerAssessments } from "./customer-assessments.model";

export abstract class CustomerAssessmentsDialogService {
	abstract open(assessmentId: string): MatDialogRef<any, any>;

	abstract openSequentialAssessments(assessments: CustomerAssessments[]): Observable<any>;
}
